export const SET_ALL = 'speakers/SET_ALL';
